import { compose, lifecycle, withHandlers, withStateHandlers, mapProps, defaultProps } from 'recompose'


export default compose(
  defaultProps({
    paginationRange: 3
  }),
  withStateHandlers(
    () => ({
      orderBy: null,
      orderAsc: false
    }),
    {
      
    }
  ),
  // Handlers
  withHandlers({
    calculatePageNumber: props => (i, totalPages) => {
      const halfWay = Math.ceil(props.paginationRange / 2)
      const currentPage = Math.ceil(props.pagination.offset / props.pagination.limit) + 1

      if (props.paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
          return (totalPages - props.paginationRange) + i
        } else if (halfWay < currentPage) {
          return (currentPage - halfWay) + i
        }
        return i
      }
      return i
    },
  }),
  withHandlers({
    generatePagesArray: ({
      pagination, paginationRange, onPageChange, calculatePageNumber 
    }) => () => {
      const pages = []

      const totalPages = Math.ceil(pagination.count / pagination.limit)
      const currentPage = Math.ceil(pagination.offset / pagination.limit) + 1
      
      if (currentPage > Math.max(1, totalPages)) {
        onPageChange((totalPages - 1) * pagination.limit)
        return []
      }
  
      let i = 1
      while (i <= totalPages && i <= paginationRange) {
        const pageNumber = calculatePageNumber(i, totalPages)
        pages.push(pageNumber)
        i += 1
      }
      if (pages.length > 0) {
        if (pages.indexOf(1) === -1) {
          if (pages[0] !== 2) {
            if (pages[0] !== 3) {
              pages.unshift('...')
            } else {
              pages.unshift(2)
            }
          }
          pages.unshift(1)
        }
        if (pages.indexOf(totalPages) === -1) {
          if (pages[pages.length - 1] !== totalPages - 1) {
            if (pages[pages.length - 1] !== totalPages - 2) {
              pages.push('...')
            } else {
              pages.push(totalPages - 1)
            }
          }
          pages.push(totalPages)
        }
      }
      return pages
    },
  }),
  lifecycle({
  }),
  mapProps((props) => {
    return props
  })
)



// WEBPACK FOOTER //
// ./src/components/organisms/PaginationControl/PaginationControl.enhancer.js